import { useEffect } from "react"

const useTitle = title => {
    useEffect(() => {
        document.title = `${title} - Logistic`;
    }, [title])
}

export default useTitle;